import Vue from 'vue';
import VueResource from 'vue-resource';

import { loadClient } from '../services/Cognito';
import { metaInfoSentiance } from './meta';

Vue.use(VueResource);

let Config = {
  LOGO_URL: require('img/logo.svg'),
  META_INFO: metaInfoSentiance,
  IMAGES: {
    GRAPHQL: require('img/graphql.svg'),
    LOADING: require('img/textinput-loading.png'),
  },
};
let isConfigLoaded = false;

// Configuration path used in nginx (docker volume mount) and path used in local development
const configLocation =
  process.env.NODE_ENV === 'production' ? '/config/index.json' : '/config.json';

export const loadConfig = async () => {
  try {
    if (!isConfigLoaded) {
      // Load config from nginx server
      const response = await Vue.http.get(configLocation);

      isConfigLoaded = true;

      Config = { ...Config, ...response.body };

      // Load Cognito client
      loadClient(Config);
    }

    return Config;
  } catch (err) {
    console.log('Configuration load failed', err);
    throw err;
  }
};

export const configs = () => {
  return Config;
};

export default {
  configs,
  loadConfig,
};
